module.exports = __webpack_public_path__ + "img/beauty-and-wellness-icon.8aeae8cc.svg";